const DEFAULT_COPY = {
  disabled: {
    title: 'Not available',
    message: 'This store is not currently available on Raheasy.',
  },
  unavailable: {
    title: 'Not available',
    message: 'This item is not currently available.',
  },
  not_found: {
    title: 'Not found',
    message: 'We could not find what you were looking for.',
  },
};

export function parseUnavailableApiPayload(data) {
  if (!data || data.available !== false) return null;
  const reason = data.reason || 'not_found';
  const defaults = DEFAULT_COPY[reason] || DEFAULT_COPY.not_found;
  const name = String(data.name || '').trim();
  let message = String(data.message || defaults.message).trim();
  if (reason === 'disabled' && name && !message.includes(name)) {
    message = `${name} is not currently available on Raheasy.`;
  }
  return {
    reason,
    title: defaults.title,
    message,
    name,
  };
}

export function isUnavailableResult(value) {
  return Boolean(value && value.__kind === 'unavailable');
}

export function createUnavailableResult(details) {
  return { __kind: 'unavailable', ...details };
}
